import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },

  container: {
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    borderRadius: 0,
    overflow: 'hidden',
  },

  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    lineHeight: 1.4,
    textTransform: 'uppercase',
    width: '25%',
  },

  keyTopicsListTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    marginTop: 20,
    marginBottom: 20,
  },
  keyTopicsListWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: 20,
    width: '80%',
  },
  keyTopicsListItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-end',
    justifyContent: 'flex-end',

    backgroundColor: 'white',
    borderRadius: '15px',
    paddingHorizontal: 20,
    paddingVertical: 10,
    width: 250,
    height: 220,
  },

  keyTopicsTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 900,
    lineHeight: 1.4,
    marginBottom: 10,
  },
  keyTopicsText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 1.4,
    marginBottom: 4,
  },

  image: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 960,
    height: 880,
    objectFit: 'cover',
    zIndex: 2,
    borderRadius: 0,
  },
});
